import { call, put, takeLatest } from "redux-saga/effects"
import { ROLES } from "./actionTypes"
import { getUserRoles } from "./actions"
import { USER_URL } from "../../helpers/url_api_helper"

function* listarUserRoles() {
  try {
    const res = yield call(USER_URL.getUserAuthenticate)
    yield put(getUserRoles.success(res.roles))
  } catch (error) {
    if (window.location.pathname !== "/document-center") {
      window.location.href = "/document-center"
    }
    yield put(getUserRoles.fail(error.response))
  }
}

function* RolesSaga() {
  yield takeLatest(ROLES.GET_ITEM.REQUEST, listarUserRoles)
}

export default RolesSaga